export const ApplicantStage = () => {
    return (<>stage</>);
};